import { makeAutoObservable } from 'mobx'
import { me } from 'store/me'
import { getTermUntil, Term, TermType } from 'type/term'
import { formatDate } from 'util/date'

export class TermFormStore {
  private _created = me.term?.created ?? Date.now()
  private _value: TermType = me.term?.type ?? TermType.FOREVER

  constructor() {
    makeAutoObservable(this)
  }

  get end(): string | undefined {
    const until = getTermUntil(this.term)
    return until ? formatDate(new Date(until)) : undefined
  }

  get value(): TermType {
    return this._value
  }

  set value(value: TermType) {
    this._value = value
    this._created = Date.now()
    me.term = this.term
  }

  private get term(): Term {
    const type = this.value
    const created = this._created
    const term = { created, type }
    return term
  }

  canBe(type: TermType): boolean {
    const created = this._created
    const until = getTermUntil({ type, created })
    return !until || Date.now() < until
  }
}
